const scrollToTopConfig: ScrollToOptions = { top: 0, left: 0, behavior: 'smooth' };

export const useScrollTopOnClick = (): (() => void) => () => {
  if (window) {
    window.scrollTo(scrollToTopConfig);
  }
};
